import FeedbackPage from '@app-studio-web/ui/pages/FeedbackPage'
import { getAllAnswers } from '@utils/onboardingStorage'
import { useTranslation } from 'react-i18next'

export default function OvercomeFeedbackPage() {
  const { t } = useTranslation()

  const allAnswers = getAllAnswers()
  const pastAttempt =
    allAnswers.v1_past_attempts?.answer_key || 'No, this is my first time'
  const gaveUp = pastAttempt === 'Yes, but I gave up'

  return (
    <FeedbackPage
      emoji="💪"
      heading={t(
        gaveUp
          ? 'pages.onboarding.overcomeFeedback.gaveUp.heading'
          : 'pages.onboarding.overcomeFeedback.general.heading',
      )}
      text={t(
        gaveUp
          ? 'pages.onboarding.overcomeFeedback.gaveUp.text'
          : 'pages.onboarding.overcomeFeedback.general.text',
      )}
      onSubmit={() => {}}
    />
  )
}
